import { render, staticRenderFns } from "./CalendarImport.vue?vue&type=template&id=3975f8b8"
import script from "./CalendarImport.vue?vue&type=script&lang=js"
export * from "./CalendarImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports